// multi select drop down

export default function ColumnSelector(props: {
  columns: string[];
  selectedColumns: string[];
  setSelected: (columns: string[]) => void;
}) {
  function handleChange(event) {
    const { checked, value } = event.target;
    console.log(checked, value);
    props.setSelected(
      checked
        // sort text > subtext > image
        ? [...new Set<string>([...props.selectedColumns, value])].sort((a, b) => {
          if (a === "text") return -1;
          if (b === "text") return 1;
          if (a === "subtext") return -1;
          if (b === "subtext") return 1;
          if (a === "audio") return -1;
          if (b === "audio") return 1;
          if (a === "image") return -1;
          if (b === "image") return 1;
          if (a === "attachments") return -1;
          if (b === "attachments") return 1;
          return 0;
        })
        : props.selectedColumns.filter((c) => c !== value),
    );
    // todo
    // props.setSelected(selectedColumns);
  }

  return (
    // show each selected column as a checkbox
    <div>
      {props.columns.map((column) => (
        <label key={column} 
        style={{ width: 200, display: 'inline-block' }}>
          <input
            type="checkbox"
            value={column}
            checked={props.selectedColumns.includes(column)}
            onChange={handleChange}
          />
          {column}
        </label>
      ))}
    </div>
  );
}
